import { getFunctions, httpsCallable } from "firebase/functions";
import { log } from "../../helper/helper";
import config from "./../../config.json";
import { getApp } from "firebase/app";

export function adminFindMotorbike(regNumber, regState) {
  const data = { registration_number: regNumber, registration_state: regState };
  log(data);
  const functions = getFunctions(getApp(), config.australiaSoutheast);
  const findMotor = httpsCallable(functions, config.adminFindMotorbike);
  log("Service name:" + config.adminFindMotorbike)
  return findMotor(data);
}

// **********************************************************************************

export function adminMotorbikeChangeHidden(motorId, isHidden) {
  const data = { motorbike_uid: motorId, is_hidden_by_user: isHidden };
  const functions = getFunctions(getApp(), config.australiaSoutheast);
  const findMotor = httpsCallable(functions, config.adminMotorbikeChangeHidden);
  log("Service name:" + config.adminMotorbikeChangeHidden)
  return findMotor(data);
}

// **********************************************************************************

export function adminCarDocumentReviewFurtherInvestigation(uid, note) {
  const data = { car_uid: uid, car_status_note: note };
  const functions = getFunctions(getApp(), config.australiaSoutheast);

  const documentReviewInvestigation = httpsCallable(
    functions,
    config.adminCarDocumentReviewFurtherInvestigation
  );
  log(data);
  log("Service name:" + config.adminCarDocumentReviewFurtherInvestigation)

  return documentReviewInvestigation(data);
}

// **********************************************************************************

export function adminMotorbikeDocumentReviewFurtherInvestigation(uid, note) {
  const data = { motorbike_uid: uid, motorbike_status_note: note };
  const functions = getFunctions(getApp(), config.australiaSoutheast);

  const documentReviewInvestigation = httpsCallable(
    functions,
    config.adminMotorbikeDocumentReviewFurtherInvestigation
  );
  log(data);
  log("Service name:" + config.adminMotorbikeDocumentReviewFurtherInvestigation)

  return documentReviewInvestigation(data);
}

// **********************************************************************************

export function adminMotorbikeDocumentReviewReject(uid, note) {
  const data = { motorbike_uid: uid, motorbike_status_note: note };
  const functions = getFunctions(getApp(), config.australiaSoutheast);

  const documentReviewReject = httpsCallable(
    functions,
    config.adminMotorbikeDocumentReviewReject
  );
  log(data);
  log("Service name:" + config.adminMotorbikeDocumentReviewReject)
  return documentReviewReject(data);
}


// **********************************************************************************

export function adminCarDocumentReviewReject(uid, note) {
  const data = { car_uid: uid, car_status_note: note };
  const functions = getFunctions(getApp(), config.australiaSoutheast);

  const documents = httpsCallable(
    functions,
    config.adminCarDocumentReviewReject
  );
  log(data);
  log("Service name:" + config.adminCarDocumentReviewReject)
  return documents(data);
}

// **********************************************************************************

export function adminMotorbikeDocumentReviewVehicleRegistration(
  uid,
  registrationNumber,
  registrationState,
  regoValidityDate
) {

  const data = {
    motorbike_uid: uid,
    registration_number: registrationNumber,
    registration_state: registrationState,
    rego_validity_date: regoValidityDate,
  };
  const functions = getFunctions(getApp(), config.australiaSoutheast);

  const documentReviewReject = httpsCallable(
    functions,
    config.adminMotorbikeDocumentReviewVehicleRegistration
  );
  log(data);
  log("Service name:" + config.adminMotorbikeDocumentReviewVehicleRegistration)

  return documentReviewReject(data);
}

// **********************************************************************************

export function adminCarDocumentReviewVehicleRegistration(
  uid,
  registrationNumber,
  registrationState,
  regoValidityDate
) {

  const data = {
    car_uid: uid,
    registration_number: registrationNumber,
    registration_state: registrationState,
    rego_validity_date: regoValidityDate,
  };
  const functions = getFunctions(getApp(), config.australiaSoutheast);
  const documents = httpsCallable(
    functions,
    config.adminCarDocumentReviewVehicleRegistration
  );
  log(data);
  log("Service name:" + config.adminCarDocumentReviewVehicleRegistration)

  return documents(data);
}


// **********************************************************************************

export function adminMotorbikeDocumentReviewVerifyInsurancePolicy(
  uid,
  policyName,
  registrationNumber,
  registrationState,
  policyNumber,
  validityDate,
  insurancePolicyType
) {

  const data = {
    motorbike_uid: uid,
    policy_name: policyName,
    registration_number: registrationNumber,
    registration_state: registrationState,
    policy_number: policyNumber,
    insurance_policy_validity_date: validityDate,
    insurance_policy_type: insurancePolicyType,
  };
  const functions = getFunctions(getApp(), config.australiaSoutheast);

  const documentReview = httpsCallable(
    functions,
    config.adminMotorbikeDocumentReviewVerifyInsurancePolicy
  );
  log(data);
  log("Service name:" + config.adminMotorbikeDocumentReviewVerifyInsurancePolicy)

  return documentReview(data);
}
// **********************************************************************************

export function adminCarDocumentReviewVerifyInsurancePolicy(
  uid,
  policyName,
  registrationNumber,
  registrationState,
  policyNumber,
  validityDate,
  insurancePolicyType
) {

  const data = {
    car_uid: uid,
    policy_name: policyName,
    registration_number: registrationNumber,
    registration_state: registrationState,
    policy_number: policyNumber,
    insurance_policy_validity_date: validityDate,
    insurance_policy_type: insurancePolicyType,
  };
  const functions = getFunctions(getApp(), config.australiaSoutheast);

  const documentReview = httpsCallable(
    functions,
    config.adminCarDocumentReviewVerifyInsurancePolicy
  );
  log(data);
  log("Service name:" + config.adminCarDocumentReviewVerifyInsurancePolicy)

  return documentReview(data);
}

// **********************************************************************************

export function adminMotorbikeRestrict(uid, statusNote) {
  const data = {
    motorbike_uid: uid,
    motorbike_status_note: statusNote,
  };
  const functions = getFunctions(getApp(), config.australiaSoutheast);

  const motorbikeRestrict = httpsCallable(
    functions,
    config.adminMotorbikeRestrict
  );
  log(data);
  log("Service name:" + config.adminMotorbikeRestrict)

  return motorbikeRestrict(data);
}

// **********************************************************************************

export function adminMotorbikeReject(uid, note) {
  const data = { motorbike_uid: uid, motorbike_status_note: note };
  const functions = getFunctions(getApp(), config.australiaSoutheast);

  const documentReviewReject = httpsCallable(
    functions,
    config.adminMotorbikeReject
  );
  log(data);
  log("Service name:" + config.adminMotorbikeReject)

  return documentReviewReject(data);
}

// **********************************************************************************

export function adminMotorbikeFurtherInvestigation(uid, note) {
  const data = { motorbike_uid: uid, motorbike_status_note: note };
  const functions = getFunctions(getApp(), config.australiaSoutheast);

  const documentReviewInvestigation = httpsCallable(
    functions,
    config.adminMotorbikeFurtherInvestigation
  );
  log(data);
  log("Service name:" + config.adminMotorbikeFurtherInvestigation)

  return documentReviewInvestigation(data);
}

// **********************************************************************************

export function adminMotorbikeApprove(uid, note) {
  const data = { motorbike_uid: uid, motorbike_status_note: note };
  const functions = getFunctions(getApp(), config.australiaSoutheast);

  const documentReviewInvestigation = httpsCallable(
    functions,
    config.adminMotorbikeApprove
  );
  log(data);
  log("Service name:" + config.adminMotorbikeApprove)

  return documentReviewInvestigation(data);
}

// **********************************************************************************

export function getAdminInfo() {
  const functions = getFunctions(getApp(), config.australiaSoutheast);

  const adminGetAdminInfo = httpsCallable(functions, config.adminGetAdminInfo);
  log("Service name:" + config.adminGetAdminInfo)

  return adminGetAdminInfo();
}
